import React from 'react'
import styled from 'styled-components'
import { MessageSquare, ArrowLeft } from 'react-feather'

import { Page, Section, Container, Button, Flex } from '../components/common'

const NoMatchPage = styled(Page)`
  h1 {
    margin-bottom: 2.5rem;
  }
  ${Flex} {
    margin-top: 2.5rem;
  }
  ${Button} {
    display: flex;
    align-items: center;

    svg {
      height: 1.25em;
      margin-right: 0.5em;
    }
  }
`

const NoMatch = ({ route }) => {
  // Check if history is from this domain
  const externalReferrer = route.history.action === 'POP'
  return (
    <NoMatchPage bgWhite>
      <Section thick>
        <Container skinny taCenter>
          <h1>404</h1>
          <p>
            We cannot find the page you are looking for.<br />
            Please let us know if this is a mistake on our behalf.
          </p>
          <Flex justifyCenter>
            <Button
              isPrimary
              to='/'
              shadow
              onClick={e => {
                // go back if internal page referrer
                if (!externalReferrer) {
                  e.preventDefault()
                  route.history.goBack()
                }
              }}
            >
              <ArrowLeft /> Go Back
            </Button>
            &emsp;
            <Button to='/more/leave-feedback' isPrimary shadow>
              <MessageSquare /> Let us know
            </Button>
          </Flex>
        </Container>
      </Section>
    </NoMatchPage>
  )
}

export default NoMatch



// WEBPACK FOOTER //
// ./src/views/NoMatch.js